<template>
	<div class="custom-textarea w-100">

		<div class="d-flex justify-start w-100 mb-1 text-14 weight-500">{{ label }}</div>

		<textarea :placeholder="placeholder" class="mt-1 w-100 auth-input pa-4"
			:class="{ 'error-textarea-border': hasError }" v-model="internalValue" @input="onInput" @blur="onBlur"
			:ref="textareaRef" rows="3"></textarea>

		<div v-if="hasError" class="d-flex align-center input-error-container">
			<Warning width="14px" height="14px" class="mr-2" />
			<span>{{ errorMessages[0] }}</span>
		</div>


	</div>
</template>



<script lang="ts" setup>

import { computed, ref, watch, onMounted } from "vue";
import Warning from "@/icons/Warning.vue";

const props = defineProps({
	label: {
		type: String,
		required: true,
	},
	placeholder: {
		type: String,
		default: "",
	},
	modelValue: {
		type: String,
		required: true,
	},
	errorMessages: {
		type: Array as () => string[],
		default: () => [],
	},
});

const emit = defineEmits(["update:modelValue", "blur"]);

const hasError = computed(() => props.errorMessages.length > 0);

// Internal state to handle the textarea value
const internalValue = ref(props.modelValue);
const textareaRef = ref<HTMLTextAreaElement | null>(null);

// Adjust textarea height for auto-grow
const adjustHeight = () => {
	const textarea = textareaRef.value;
	if (textarea) {
		textarea.style.height = "auto";
		textarea.style.height = `${textarea.scrollHeight}px`;
	}
};

// Watch for external changes to modelValue
watch(() => props.modelValue, (newVal) => {
	internalValue.value = newVal;
	adjustHeight();
});

// Watch internal value and adjust height
watch(internalValue, () => {
	adjustHeight();
});

// Initial adjustment on mounted
onMounted(() => {
	adjustHeight();
});

const onInput = (event: Event) => {
	const target = event.target as HTMLTextAreaElement;
	emit("update:modelValue", target.value);
};

const onBlur = () => {
	emit("blur");
};

</script>



<style scoped lang="scss">
@use '@/assets/scss/_input-mixins.scss' as input-mixins;
</style>